import AOS from '../../../../../../node_modules/aos/dist/aos.js';

class Tabs
{
  #activeTab = null;
  #tabElement = null;
  #tabDesktopForm = null;
  #tabMobileForm = null;
  #tabSelected = null;

  constructor(tabElement, defaultTab = 'default')
  {
    console.log('init blog tabs')
    this.#tabElement = tabElement;
    this.#tabDesktopForm = this.#tabElement.querySelector('[data-tabs-desktop-form]');
    this.#tabMobileForm = this.#tabElement.querySelector('[data-tabs-form]');
    this.#tabSelected = this.#tabElement.querySelector('[data-tab-selected]');
    this.init();
  }

  init()
  {
    this.#tabDesktopForm.addEventListener('change', (e) =>
    {
      e.preventDefault();
      const name = this.#tabDesktopForm.querySelector(`label[for="${e.target.id}"]`).textContent;
      this.changeTab(e.target.value, name);
    });

    this.#tabMobileForm.addEventListener('change', (e) =>
    {
      e.preventDefault();
    });

    this.#tabMobileForm.addEventListener('submit', (e) =>
    {
      e.preventDefault();
      const value = this.#tabMobileForm.querySelector('input:checked').value;
      const name = this.#tabMobileForm.querySelector('input:checked + label').textContent;

      this.changeTab(value, name);
    });

    setTimeout(() =>
    {
      let urlArray = window.location.pathname.split("/")

      let url = urlArray[urlArray.length - 1];
      if (url == ''){
        url = urlArray[urlArray.length - 2];
      }

      console.log('category '+url);
     
      let descChecks = this.#tabDesktopForm.querySelectorAll('input[type=radio]')
      descChecks.forEach((descCheck) =>
      {
        if ((descCheck.value == '/blog/' + url + '/') || ((url == 'blog') && (descCheck.value == '/blog/'))){
          descCheck.checked = true;
        }else{
          descCheck.checked = false;
        }
      });

      let mobileChecks = this.#tabMobileForm.querySelectorAll('input[type=radio]')
      mobileChecks.forEach((mobileCheck) =>
      {
        if ((mobileCheck.value == '/blog/' + url + '/') || ((url == 'blog') && (mobileCheck.value == '/blog/'))){
          mobileCheck.checked = true;
        }else{
          mobileCheck.checked = false;
        }
      });

      let name = this.#tabMobileForm.querySelector('input:checked + label').textContent;
      this.#tabSelected.textContent = name;

    }, 100);
  }

  changeTab = (value, name) =>
  {
    AOS.refresh();

    this.#activeTab = value;

    this.#tabSelected.textContent = name;

    console.log(value)

    window.open(value, "_self");

    this.#tabDesktopForm.querySelector(`input[value="${value}"]`).checked = true;
    this.#tabMobileForm.querySelector(`input[value="${value}"]`).checked = true;
  };

}

const initTabs = () =>
{
  const tabs = document.querySelectorAll('[data-blog-tabs]');
  if(tabs.length)
  {
    tabs.forEach((tab) =>
    {
      const tabElement = new Tabs(tab);
    });
  }
};

export { initTabs };
